import amplitude from 'amplitude-js'
import ObjectId from 'bson-objectid'
import _ from 'lodash'

const key =
  process.env.REACT_APP_ENV === 'production'
    ? 'c720affbd112e1fba5b3058292313684'
    : '8094dd1c9ea36844867f8e1d360d067e'

class Amplitude {
  constructor() {
    this.amp = amplitude.getInstance()
    this.amp.init(key)
    window.AMP_CLIENT = this.amp
    this.context = 'downloads-page'
    this.sessionId = ObjectId().str
  }

  setUser(user) {
    try {
      this.email = user.email
      this.licence = user.licence_configuration.base_template.code
      this.organization = _.maxBy(user.organizations, v => v.priority).organization.code
      this.company = user.company
      this.job = user.job
      this.sport = user.sport
      this.referral = user.referral
      this.language = user.language

      this.amp.setUserId(this.email)
      this.amp.setUserProperties({
        id: user._id,
        email_notifications: user.email_notifications,
        name: user.name,
        licence: this.licence,
        organization: this.organization,
        company: user.company,
        job: user.job,
        sport: user.sport,
        referral: user.referral,
        language: user.language,
        lastUpdate: user.lastUpdate,
        last_login: user.last_login
      })

      window.MetricaSportsAnalytics.setUser(user._id, user)
    } catch (e) {
      console.warn('Could not set up user in Amplitude')
    }
  }

  logEvent(action) {
    const isProd = process.env.REACT_APP_ENV === 'production'
    try {
      this.amp.logEvent(action, {
        action: action || undefined,
        context: this.context,
        licence: this.licence,
        organization: this.organization,
        sessionId: this.sessionId,
        user: this.email,
        company: this.company,
        job: this.job,
        sport: this.sport,
        referral: this.referral,
        language: this.language
      })

      if (!isProd) {
        console.log(`Amplitud event: ${action} registered`)
      }
    } catch (error) {
      if (!isProd) {
        console.log(`Amplitud event: ${action} ERROR`, error)
      }
    }
  }
}

// Amplitud Event
// {
//   action: string (comes from the constants for Analytics),
//   context: 'downloads-page',
//   licence: mainLicence.licence.code,
//   organization: mainLicence.organization.code,
//   sessionId: generate or get a session ID,
//   user: user's email,
//   company: user's company,
//   job: user's job,
//   sport: user's sport,
//   referral: user's referral,
//   language: user's language
// }

export default new Amplitude()
